import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { WaitingDialogComponent } from '../../shared/waiting-dialog/waiting-dialog.component';
import { CartAttributes, CartDetailAttributes } from '../cart';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { CartService } from '../cart.service';
import { Config } from '../../services/env.config';
import { Subject } from 'rxjs';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { SuccessDialogComponent } from '../../shared/success-dialog/success-dialog.component';
import { UploadErrorMsgComponent } from '../../shared/upload-error-msg/upload-error-msg.component';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { WaitingwhiteDialogComponent } from 'src/app/shared/waitingwhite-dialog/waitingwhite-dialog.component';
import { ProductDetailPopupComponent } from 'src/app/product-list/product-detail-popup/product-detail-popup.component';
import { ErrorDialogComponent } from 'src/app/shared/error-dialog/error-dialog.component';
import { PopupWithoutConfirmComponent } from 'src/app/shared/popup-without-confirm/popup-without-confirm.component';

@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss']
})
export class AddToCartComponent implements OnInit {
  IdsToDelete: string = '';
  qtyInput: string;
  newProductDetailForCart: CartDetailAttributes = new CartDetailAttributes();
  newProductForCart: CartAttributes = new CartAttributes();
  ProductDetailForplaceorder: CartDetailAttributes = new CartDetailAttributes();
  newProductForOrder: CartAttributes = new CartAttributes();
  @ViewChild('model', { static: true }) input: ElementRef;
  imageBaseUrl = Config.BaseEndpoint + 'itemImages/downloadItemImageByFileNameAsResource/';
  ConfirmationModalRef: MDBModalRef;
  updatedQtyForProduct: CartDetailAttributes = new CartDetailAttributes();
  selectedIdToRemove: number;
  cartDEtails: CartDetailAttributes = new CartDetailAttributes();
  waitingModalRef: MDBModalRef;
  filename: string;
  fileData: any;
  cartDetails: CartAttributes;
  cartDetailsVo: any[] = [];
  emptyCartFlag: boolean;
  tempCartDetailsVo: any[];
  uploadFormRef: MDBModalRef;
  length: any;
  loggedInUser: any
  constructor(private cartService: CartService, private _sanitizer: DomSanitizer, private modalService: MDBModalService, private router: Router) {
    this.loggedInUser = JSON.parse(sessionStorage.getItem('user'));
  }


  ngOnInit() {

    this.getCartDetails();
     this.cartService.cartUpdated$.subscribe(() => {
      this.getCartDetails();
    });
  }

  openModal() {
    this.ConfirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
      data: {
        message: 'Do you really want to delete this product?'
      }
    });
    this.ConfirmationModalRef.content.action.subscribe((result: any) => {
      if (result == 'yes') {
        this.cartService.deleteItemsFromCart(this.selectedIdToRemove).then((data) => {
          this.ConfirmationModalRef.hide();
          this.getCartDetails();
        });
      }
      else {
        this.ConfirmationModalRef.hide();
      }
    });
  }

  updateQtyForExistingProduct(cartDetailDomainId, existingQuantity) {
    this.updatedQtyForProduct = new CartDetailAttributes();
    this.updatedQtyForProduct.cartDetailDomainId = cartDetailDomainId;
    this.updatedQtyForProduct.Qty = existingQuantity;
    this.cartService.updateQuantityForExistingProduct(this.updatedQtyForProduct).then((data: any) => {
      this.getCartDetails();

    });
  }

  removeProductFromCart() {
    this.cartService.deleteAllItemsFromCart().then((data) => {
      this.getCartDetails();
    });
  }

  selectItem(id) {
    this.selectedIdToRemove = id;
    this.openModal();
  }

  openUploadForm() {
    this.uploadFormRef = this.modalService.show(UploadFormComponent, {
      data: {
        message: ''
      }
    });
    this.uploadFormRef.content.action.subscribe((result: any) => {
      if (result == 'yes') {
        this.uploadFormRef.hide();
        this.getCartDetails();
      }
    });
  }
  totalProductsCount: number = 0;
  totalCartValue: number = 0;
  totalAmount: number = 0;

  getCartDetails() {
    this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
      data: {
        message: 'Loading Cart'
      }
    })
    //debugger;
    this.cartService.getCartDetailsForUser().then((data: any) => {
      this.cartDEtails = data;
      this.cartDetailsVo = [];
      this.length = data.length;
      setTimeout(x => {
        this.waitingModalRef.hide();
      }, 300)
      this.totalCartValue = 0;
      this.totalProductsCount = 0;
      this.totalAmount = 0;
      if (this.cartDEtails != null) {
        this.emptyCartFlag = false;
        for (let i = 0; i < this.length; i++) {
          this.cartDetailsVo.push(this.cartDEtails[i]);
        }
        if (this.cartDetailsVo.length != 0) {
          for (let element of this.cartDetailsVo) {
            this.totalCartValue += element.NetPrice;
            this.totalAmount += element.TotalPrice;
            this.totalProductsCount += element.Qty;
            element.deleteFlag = false;
            if (element.ProdImage != null) {
              element.ProdImage = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
                + element.ProdImage);
            }
            else {
              element.ProdImage = 'assets/img/NoImage.png';
            }
          }

        }
        else {
        }
      }
      else {
        this.emptyCartFlag = true;
        setTimeout(x => {
        }, 300)
      }
    }, error => {
      setTimeout(x => {
        this.waitingModalRef.hide();
      }, 300)
    });
  }

  openPreFilledForm() {

  }



  deleteMultipleitem() {
    for (let element of this.cartDetails.cartDetailVo) {
      if (element.deleteFlag) {
        this.IdsToDelete += element.cartDetailDomainId + ','
      }
    }
    this.cartService.deleteItemsFromCart(this.IdsToDelete.slice(0, -1)).then((data) => {
      this.ConfirmationModalRef.hide();
      this.getCartDetails();
    });
  }

  successModalRef: MDBModalRef;
  idleBtn: boolean = false;
  
//previous
//   createSalesOrder() {

//     if (this.cartDetailsVo.length === 0) {
//       alert("Cart is empty.");
//       return;
//     }

//     this.idleBtn = true;

//     // ===== CONFIRMATION MODAL =====
//     this.ConfirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
//       data: { message: 'Do you really want to place this order?' }
//     });

//     this.ConfirmationModalRef.content.action.subscribe((result: any) => {

//       if (result !== 'yes') {
//         this.ConfirmationModalRef.hide();
//         this.idleBtn = true;
//         return;
//       }

//       this.ConfirmationModalRef.hide();

//       let User = JSON.parse(sessionStorage.getItem('user'));
//       let DealUserName = JSON.parse(sessionStorage.getItem('DealUserName'));

//       // ===== COMMON API CALL FUNCTION =====
//       const callPlaceOrderApi = (isOrderFlag: boolean) => {

//         this.newProductForOrder.cartDetailVo = [];

//         for (let i = 0; i < this.cartDetailsVo.length; i++) {
//           let product = new CartDetailAttributes();
//           product.UserName = User.UserName;
//           product.DealUserName = DealUserName;
//           product.ProductCode = this.cartDetailsVo[i].ProductCode;
//           product.Qty = this.cartDetailsVo[i].Qty;
//           product.isorder = isOrderFlag;
//           product.OrderType = this.cartDetailsVo[i].OrderType;

//           this.newProductForOrder.cartDetailVo.push(product);
//         }

//         return this.cartService.createSaleOrderFromCart(
//           this.newProductForOrder.cartDetailVo
//         );
//       };

//       // ===== FINAL ORDER FUNCTION (YES FLOW) =====
//       const proceedWithFinalOrder = () => {

//         callPlaceOrderApi(true).then((finalData: any) => {

//           if (finalData && finalData.IsSuccess === false) {
//             alert(finalData.Message || 'Order failed');
//             return;
//           }

//           this.getCartDetails();

//           let msg = "Order Placed Successfully, Order No : " + finalData.Response;

//           this.successModalRef = this.modalService.show(SuccessDialogComponent, {
//             data: { message: msg, data: [] }
//           });

//           this.successModalRef.content.action.subscribe(r => {
//             if (r === 'OK') {
//               this.successModalRef.hide();
//               this.router.navigate(['/main/cart/my-orders']);
//             }
//           });
//         });
//       };

//       // ===== FIRST API CALL (isorder = false) =====
//       callPlaceOrderApi(false).then((data: any) => {

//         // ===== ERROR CASE =====
//         if (data && data.IsSuccess === false) {

// let errorMessage = data.Message || 'Something went wrong. Do you want to proceed?';
// let title = data.Title || 'Message';
//           // this.successModalRef = this.modalService.show(PopupWithoutConfirmComponent, {
//           //   data: { message: errorMessage }
//           // });
//           this.successModalRef = this.modalService.show(PopupWithoutConfirmComponent, {
//             data: {title: title, message: errorMessage },
//             ignoreBackdropClick: true,
//             keyboard: false
//           });

//           let userResponded = false;

//           // ⏱ AUTO YES AFTER 2 SECONDS
//           const autoYesTimer = setTimeout(() => {
//             if (!userResponded) {
//               userResponded = true;
//               this.successModalRef.hide();
//               proceedWithFinalOrder();
//             }
//           }, 4000);

//           // 👇 USER CLICK YES / NO
//           this.successModalRef.content.action.subscribe(res => {
//             userResponded = true;
//             clearTimeout(autoYesTimer);
//             this.successModalRef.hide();

//             if (res === 'yes') {
//               proceedWithFinalOrder();
//             }
//             // NO → do nothing
//           });

//           return;
//         }

//         // ===== FIRST CALL SUCCESS =====
//         this.getCartDetails();

//         let msg = "Order Placed Successfully, Order No : " + data.Response;

//         this.successModalRef = this.modalService.show(SuccessDialogComponent, {
//           data: { message: msg, data: [] }
//         });

//         this.successModalRef.content.action.subscribe(r => {
//           if (r === 'OK') {
//             this.successModalRef.hide();
//             this.router.navigate(['/main/cart/my-orders']);
//           }
//         });
//       });
//     });
//   }

//new 
isOrderCreating: boolean = false;
createSalesOrder() {

  // ===== CART EMPTY CHECK =====
  if (this.cartDetailsVo.length === 0) {
    alert("Cart is empty.");
    return;
  }

  // ===== PREVENT MULTIPLE CONFIRMATION CLICKS =====
  if (this.isOrderCreating) {
    return;
  }

  this.idleBtn = true;

  // ===== CONFIRMATION MODAL =====
  this.ConfirmationModalRef = this.modalService.show(
    ConfirmDialogComponent,
    {
      data: {
        message: 'Do you really want to place this order?'
      }
    }
  );

  this.ConfirmationModalRef.content.action.subscribe(
    (result: any) => {

      // ==========================================
      // NO / CANCEL
      // ==========================================
      if (result !== 'yes') {

        this.ConfirmationModalRef.hide();

        // Allow checkout again
        this.idleBtn = false;
        this.isOrderCreating = false;

        return;
      }

      // ==========================================
      // IMPORTANT:
      // PREVENT DOUBLE YES CLICK
      // ==========================================
      if (this.isOrderCreating) {
        return;
      }

      // Lock immediately BEFORE any API call
      this.isOrderCreating = true;
      this.idleBtn = true;

      this.ConfirmationModalRef.hide();

      const User = JSON.parse(
        sessionStorage.getItem('user')
      );

      const DealUserName = JSON.parse(
        sessionStorage.getItem('DealUserName')
      );

      // ==========================================
      // COMMON API CALL FUNCTION
      // ==========================================
      const callPlaceOrderApi = (isOrderFlag: boolean) => {

        this.newProductForOrder.cartDetailVo = [];

        for (let i = 0; i < this.cartDetailsVo.length; i++) {

          const product = new CartDetailAttributes();

          product.UserName = User.UserName;
          product.DealUserName = DealUserName;
          product.ProductCode =
            this.cartDetailsVo[i].ProductCode;
          product.Qty =
            this.cartDetailsVo[i].Qty;
          product.isorder = isOrderFlag;
          product.OrderType =
            this.cartDetailsVo[i].OrderType;

          this.newProductForOrder.cartDetailVo.push(
            product
          );
        }

        console.log(
          'Calling CreateSaleOrder API:',
          isOrderFlag,
          this.newProductForOrder.cartDetailVo
        );

        return this.cartService.createSaleOrderFromCart(
          this.newProductForOrder.cartDetailVo
        );
      };

      // ==========================================
      // FINAL ORDER FUNCTION
      // ==========================================
      const proceedWithFinalOrder = () => {

        // IMPORTANT:
        // Do not call final API if already processing
        if (!this.isOrderCreating) {
          return;
        }

        callPlaceOrderApi(true)
          .then((finalData: any) => {

            console.log(
              'Final order response:',
              finalData
            );

            // ===== FINAL API ERROR =====
            if (
              finalData &&
              finalData.IsSuccess === false
            ) {

              alert(
                finalData.Message ||
                'Order failed'
              );

              // Allow retry after failure
              this.isOrderCreating = false;
              this.idleBtn = false;

              return;
            }

            // ===== SUCCESS =====
            this.getCartDetails();

            const msg =
              "Order Placed Successfully, Order No : " +
              finalData.Response;

            this.successModalRef =
              this.modalService.show(
                SuccessDialogComponent,
                {
                  data: {
                    message: msg,
                    data: []
                  }
                }
              );

            this.successModalRef.content.action.subscribe(
              (r: any) => {

                if (r === 'OK') {

                  this.successModalRef.hide();

                  this.router.navigate([
                    '/main/cart/my-orders'
                  ]);

                }

              }
            );

          })
          .catch((error: any) => {

            console.error(
              'Final order API failed:',
              error
            );

            // Allow retry only when API fails
            this.isOrderCreating = false;
            this.idleBtn = false;

            alert(
              'Something went wrong while placing the order.'
            );

          });
      };

      // ==========================================
      // FIRST API CALL
      // isorder = false
      // ==========================================
      callPlaceOrderApi(false)
        .then((data: any) => {

          console.log(
            'First order API response:',
            data
          );

          // ========================================
          // FIRST API ERROR
          // ========================================
          if (
            data &&
            data.IsSuccess === false
          ) {

            const errorMessage =
              data.Message ||
              'Something went wrong. Do you want to proceed?';

            const title =
              data.Title ||
              'Message';

            this.successModalRef =
              this.modalService.show(
                PopupWithoutConfirmComponent,
                {
                  data: {
                    title: title,
                    message: errorMessage
                  },
                  ignoreBackdropClick: true,
                  keyboard: false
                }
              );

            let userResponded = false;

            // ======================================
            // AUTO YES AFTER 4 SECONDS
            // ======================================
            const autoYesTimer = setTimeout(() => {

              if (!userResponded) {

                userResponded = true;

                this.successModalRef.hide();

                proceedWithFinalOrder();
              }

            }, 4000);

            // ======================================
            // USER YES / NO
            // ======================================
            this.successModalRef.content.action.subscribe(
              (res: any) => {

                // Prevent duplicate response
                if (userResponded) {
                  return;
                }

                userResponded = true;

                clearTimeout(autoYesTimer);

                this.successModalRef.hide();

                if (res === 'yes') {

                  proceedWithFinalOrder();

                } else {

                  // User selected NO
                  this.isOrderCreating = false;
                  this.idleBtn = false;
                }

              }
            );

            return;
          }

          // ========================================
          // FIRST API SUCCESS
          // ========================================
          this.getCartDetails();

          const msg =
            "Order Placed Successfully, Order No : " +
            data.Response;

          this.successModalRef =
            this.modalService.show(
              SuccessDialogComponent,
              {
                data: {
                  message: msg,
                  data: []
                }
              }
            );

          this.successModalRef.content.action.subscribe(
            (r: any) => {

              if (r === 'OK') {

                this.successModalRef.hide();

                this.router.navigate([
                  '/main/cart/my-orders'
                ]);

              }

            }
          );

        })
        .catch((error: any) => {

          console.error(
            'First order API failed:',
            error
          );

          // Allow retry after API failure
          this.isOrderCreating = false;
          this.idleBtn = false;

          alert(
            'Something went wrong while placing the order.'
          );

        });

    }
  );
}




  DetailModalRef: MDBModalRef;
  openDetailPopup(productDetail, event) {
    this.DetailModalRef = this.modalService.show(ProductDetailPopupComponent, {
      data: {
        message: productDetail
      }, class: 'modal-lg', backdrop: 'static'
    });
    this.DetailModalRef.content.action.subscribe(result => {
      if (result == 'OK') {
        this.DetailModalRef.hide();
      }
      if (result == 'CartDetails') {
        this.DetailModalRef.hide();
        this.router.navigate(['/main/cart/detail'])
      }

    })
  }

  emptyCart() {
    this.ConfirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
      data: {
        message: 'Do you really want to empty the CART?'
      }
    });
    this.ConfirmationModalRef.content.action.subscribe((result: any) => {
      if (result == 'yes') {
        this.ConfirmationModalRef.hide();
        this.removeProductFromCart();
      }
      else {
        this.ConfirmationModalRef.hide();
      }
    });
  }

  applyFilter(filterValue: any): void {
    this.cartDetailsVo = this.tempCartDetailsVo.filter(x => x.itemCode.includes(filterValue.trim().toLowerCase()));
  }

  checkPro(element) {
    this.updateQtyForExistingProduct(element.cartDetailDomainId, element.qty)
  }
  confirmModalRef: MDBModalRef;
  checkQuantity(type, element) {
    console.log('cart', element)
    let User = JSON.parse(sessionStorage.getItem('user'))
    let DealUserName = JSON.parse(sessionStorage.getItem('DealUserName'));

    this.selectedIdToRemove = element.cartDetailDomainId
    this.newProductDetailForCart = new CartDetailAttributes();
    this.newProductForCart.cartDetailVo = [];
    this.newProductDetailForCart.ProductCode = element.ProductCode;

    this.newProductDetailForCart.UserName = User.UserName;
    this.newProductDetailForCart.DealUserName = DealUserName;
    this.newProductDetailForCart.SNo = 0;
    if (type == 'add') {
      element.Qty++;
      // if( element.Qty > element.Stock ){

      //   this.confirmModalRef = this.modalService.show(ErrorDialogComponent, {
      //     data: {
      //       message: "The Product "+element.ProductCode+"'s Qty Cannot be greater than available stock",
      //       data: []
      //      }
      //   });
      //  this.confirmModalRef.content.action.subscribe(result => {
      //    if (result == 'OK') {
      //     element.Qty--;
      //      this.confirmModalRef.hide();
      //    }
      //  })
      //  return;
      // }
      this.newProductDetailForCart.Qty = element.Qty;
      this.newProductForCart.cartDetailVo.push(this.newProductDetailForCart);
      this.cartService.saveNewProductToCart(this.newProductForCart.cartDetailVo).then((data) => {
        if (data[0].ErrorName == "Saved") {
          this.getCartDetails();
        } else if (data[0].ErrorName == "error") {
          alert("Something went wrong");
        }
        else {
          alert("Product Code is not Present");
        }
      });
    }
    else {
      if (element.Qty > 1) {
        element.Qty--;
        this.newProductDetailForCart.Qty = element.Qty;
        this.newProductForCart.cartDetailVo.push(this.newProductDetailForCart);
        this.cartService.saveNewProductToCart(this.newProductForCart.cartDetailVo).then((data) => {
          if (data[0].ErrorName == "Saved") {
            this.getCartDetails();
          } else if (data[0].ErrorName == "error") {
            alert("Something went wrong");
          }
          else {
            alert("Product Code is not Present");
          }
        });
      }
      else {
        this.selectItem(element.ProductCode)

      }

    }

  }


}

@Component({
  selector: 'app-upload-item',
  templateUrl: './item-upload.component.html',
  styleUrls: ['./add-to-cart.component.scss']
})
export class UploadFormComponent implements OnInit {
  
  action: Subject<any> = new Subject();
  waitingModalRef: MDBModalRef
  uploadUrl: string;
  filename: string;
  fileData: any;
  @ViewChild('fileInput', { static: false }) elem: ElementRef;
  loggedInUserDetail: any;
  constructor(private router: Router, private modalService: MDBModalService, private http: HttpClient, private cartService: CartService, public modalRef: MDBModalRef) {
    this.loggedInUserDetail = JSON.parse(sessionStorage.getItem('user'))

  }
  ngOnInit() {

  }

  onClose() {
    this.action.next('yes');
    this.modalRef.hide();
  }
  isValidCSVFile(file: any) {
    return file.name.endsWith(".csv") || file.name.endsWith(".CSV");
  }
  successModalRef: MDBModalRef;
  uploadListener($event: any): void {

    let files = $event.srcElement.files;

    if (this.isValidCSVFile(files[0])) {

      let input = $event.target;
      this.filename = input.files[0].name;
      var bytes = [];
      var fileReader = new FileReader();
      fileReader.readAsBinaryString(input.files[0]);
      fileReader.onload = () => {
        var data = fileReader.result as String;
        for (var i = 0; i < data.length; ++i) {
          bytes.push(data.charCodeAt(i));
          bytes.push(0);
        }
        this.fileData = bytes;
        let Data = String.fromCharCode.apply(String, bytes);
       // console.log("string", Data);
        //console.log("bytes", bytes);
      };
      fileReader.onerror = function () {
        console.log('error is occured while reading file!');
      };

    } else {
      alert("Please import valid .csv file.");
    }
  }

  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };

  uploadfile() {
    if (this.fileData) {
      this.waitingModalRef = this.modalService.show(WaitingwhiteDialogComponent, {
        data: {
          message: 'Upload Products to Cart'
        }
      });
      let data = JSON.parse(sessionStorage.getItem('user'));
      let DealUserName = JSON.parse(sessionStorage.getItem('DealUserName'));

      let file = { UserName: data.UserName, DealUserName: DealUserName, FileName: this.filename, File: this.fileData }
      this.http
        .post(Config.BaseEndpoint + '/UploadOrder', JSON.stringify(file), this.cpHeaders)
        .toPromise()
        .then((response: any) => {
         
         
           this.waitingModalRef.hide();
          this.showSuccessMessage(response);
           this.onClose();
          // debugger;
          this.cartService.getCartDetailsForUser().then((data: any) => {
            setTimeout(x => {
            }, 300)
          })
            setTimeout(x => {
                    this.getCartCount();

            }, 300)
         // Notify cart update
      this.cartService.notifyCartUpdated();

          return response;
        })
        .catch((error) => {
          this.waitingModalRef.hide();
          return Promise.reject(error);
        });
    }
  }

 getCartCount() {
    this.cartService.getCartCount().then((response) => {
    })
  }
  // showSuccessMessage(errdata) {
  //   let data = errdata;
  //   let message;
  //   if (data[0].ErrorName == "Saved" || data[0].ErrorName == "saved") {
  //     message = "Items added to cart";
  //     data = [];
  //   } else if (data[0].ErrorName == "Error" || data[0].ErrorName == "error") {
  //     message = "Something went wrong";
  //     data = [];
  //   } else {
  //     // message = data[0].Description;
  //     message = "Quantity cannot be more than available stock /SKU Code not available"
  //   }
  //   this.successModalRef = this.modalService.show(SuccessDialogComponent, {
  //     data: {
  //       message: message,
  //       data: data
  //     }
  //   });
  //   this.successModalRef.content.action.subscribe(result => {
  //     if (result == 'OK') {
  //       this.successModalRef.hide();
  //       window.location.reload();
  //       // this.action.next('save');
  //     }
  //   })
  // }

showSuccessMessage(responseData: any) {

  let message = '';
  let warnings = [];

  for (let i = 0; i < responseData.length; i++) {

    if (responseData[i].ErrorName === 'Saved') {
      message = 'Items added to cart';
    }

    if (responseData[i].ErrorName === 'Error') {
      warnings.push({
        ProductCode: responseData[i].ProductCode,
        Description: responseData[i].Description
      });
    }
  }

  this.successModalRef = this.modalService.show(SuccessDialogComponent, {
    data: {
      message: message,
      warnings: warnings
    }
  });

  this.successModalRef.content.action.subscribe(result => {
    if (result === 'OK') {
       //window.location.reload();
      this.successModalRef.hide();
             //this.router.navigate(['/main/cart/detail']);

     
    }
  });
}

}

